<template lang="pug">
#modal-atalho-territorio
    el-dialog(
        width='600px',
        :title= "$t('mensagens.territorio.modalAtalhoCadastro.titulo')",
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        span.espacamento
            | {{ $t('mensagens.territorio.modalAtalhoCadastro.novoTerritorioVinculadoAPessoa') }}
        .botoes
            BaseButton(@click='fechar') {{ $t('mensagens.comuns.voltar') }}
            BaseButton(type='primary', @click='irParaTerritorio') {{ $t('mensagens.comuns.cadastrar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalAtalhoTerritorio',
    components: {
        BaseButton
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        irParaTerritorio() {
            this.$router.push({
                name: 'CadastrarEditarTerritorio',
                params: { cadastrar: 'pessoa' }
            });
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>
<style lang="scss">
.botoes {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
}

.espacamento {
    word-break: break-word;
}
</style>
